"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const OperationalContext_1 = __importDefault(require("../OperationalContext/OperationalContext"));
const Spinner_1 = __importDefault(require("../Spinner/Spinner"));
const utils_1 = require("../utils");
const constants_1 = require("../utils/constants");
const styled_1 = __importDefault(require("../utils/styled"));
exports.makeColors = (theme, color) => {
    const defaultColor = theme.color.white;
    const backgroundColors = {
        grey: theme.color.background.light,
        warning: defaultColor,
    };
    const textColors = {
        grey: theme.color.text.action,
        warning: theme.color.error,
    };
    const borderColors = {
        ghost: "transparent",
    };
    const backgroundColor = backgroundColors[color] || constants_1.expandColor(theme, color) || defaultColor;
    const textColor = textColors[color] || utils_1.readableTextColor(backgroundColor, [theme.color.text.default, theme.color.white]);
    const borderColor = borderColors[color] || (utils_1.isWhite(backgroundColor) ? theme.color.border.disabled : backgroundColor);
    return {
        background: backgroundColor,
        foreground: textColor,
        border: borderColor,
    };
};
const ButtonSpinner = styled_1.default(Spinner_1.default)(({ theme, containerColor }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate3d(-50%, -50%, 0)",
    color: exports.makeColors(theme, containerColor || "").foreground,
}));
const BaseButton = styled_1.default("button")(({ theme, color_, disabled, condensed, loading, fullWidth, textColor }) => {
    const { background: backgroundColor, foreground: foregroundColor, border: borderColor } = exports.makeColors(theme, color_ || "");
    return Object.assign({ backgroundColor, lineHeight: `${condensed ? 26 : 34}px`, minWidth: "max-content", fontSize: theme.font.size.small, fontFamily: theme.font.family.main, fontWeight: theme.font.weight.medium, display: "inline-flex", alignItems: "center", justifyContent: "center", padding: `0 ${condensed ? theme.space.medium : theme.space.element}px`, borderRadius: theme.borderRadius, border: `1px solid ${borderColor}`, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.6 : 1.0, position: "relative", width: fullWidth ? "100%" : "initial", marginRight: theme.space.small, 
        // Apply styles with increased specificity to override defaults
        "&, a:link&, a:visited&": {
            textDecoration: "none",
            color: loading ? "transparent" : constants_1.expandColor(theme, textColor) || foregroundColor,
        }, "&:focus": Object.assign({}, utils_1.inputFocus({ theme, isError: color_ === "error" }), { 
            //Higher zIndex will make right border appear on ButtonGroup Focus.
            zIndex: theme.zIndex.confirm }), ".no-focus &:focus": {
            boxShadow: "none",
        } }, (!disabled
        ? {
            ":hover, .no-focus &:hover:focus": {
                backgroundColor: utils_1.darken(backgroundColor, 5),
                zIndex: theme.zIndex.confirm,
            },
        }
        : {}));
});
const Button = (_a) => {
    var { to, children, icon: Icon, iconPosition, iconSize = 18, iconColor, color, onClick, tabIndex } = _a, props = __rest(_a, ["to", "children", "icon", "iconPosition", "iconSize", "iconColor", "color", "onClick", "tabIndex"]);
    const iconProps = { size: iconSize, color: iconColor };
    return (React.createElement(OperationalContext_1.default, null, ctx => (React.createElement(BaseButton, Object.assign({}, props, { as: to ? "a" : undefined, role: "button", "aria-label": typeof children === "string" ? children : undefined, tabIndex: tabIndex, color_: color, href: to, onClick: (ev) => {
            if (props.disabled) {
                ev.preventDefault();
                return;
            }
            if (onClick) {
                onClick();
            }
            if (!utils_1.isModifiedEvent(ev) && ctx.pushState && to && !utils_1.isOutsideLink(to)) {
                ev.preventDefault();
                ctx.pushState(to);
            }
        }, title: props.loading && children === String(children) ? String(children) : undefined }),
        Icon && iconPosition === "start" && React.createElement(Icon, Object.assign({ left: true }, iconProps)),
        children,
        Icon && iconPosition === "end" && React.createElement(Icon, Object.assign({ right: true }, iconProps)),
        props.loading && React.createElement(ButtonSpinner, { containerColor: color })))));
};
Button.defaultProps = {
    iconPosition: "end",
};
exports.default = Button;
//# sourceMappingURL=Button.js.map